import { render, staticRenderFns } from "./FormConfiguration.vue?vue&type=template&id=7e535c66&scoped=true"
import script from "./FormConfiguration.vue?vue&type=script&lang=js"
export * from "./FormConfiguration.vue?vue&type=script&lang=js"
import style0 from "./FormConfiguration.vue?vue&type=style&index=0&id=7e535c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e535c66",
  null
  
)

export default component.exports